import { lazy } from '../../../shared/deployment';

export const JMTLogin = lazy(() => import('./JMTLogin'));
export const AuthCatcher = lazy(() => import('./AuthCatcher'));
export const TestJwtToken = lazy(() => import('./TestJwtToken'));
